"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinimalMembership = exports.MinimalGroup = exports.ClientMessagingGroup = exports.ClientDispatchGroup = exports.ClientMessagingGroupPermissions = exports.ClientDispatchGroupPermissions = exports.AgencyGroup = exports.BasicAgencyGroup = exports.SearchDispatchGroup = exports.MinimalDispatchGroup = exports.MinimalAgencyGroup = exports.NamedGroup = exports.AgencyGroupTypeEnum = void 0;
exports.parseClientGroup = parseClientGroup;
var cerealParse_1 = require("../cerealParse");
var responseOption_1 = require("./responseOption");
var override_1 = require("./override");
var AgencyGroupTypeEnum;
(function (AgencyGroupTypeEnum) {
    AgencyGroupTypeEnum[AgencyGroupTypeEnum["dispatch"] = 0] = "dispatch";
    AgencyGroupTypeEnum[AgencyGroupTypeEnum["messaging"] = 1] = "messaging";
})(AgencyGroupTypeEnum || (exports.AgencyGroupTypeEnum = AgencyGroupTypeEnum = {}));
/**
 * Class representing a named group and providing a static parse method.
 */
var NamedGroup = /** @class */ (function () {
    function NamedGroup(id, name) {
        this.id = id;
        this.name = name;
    }
    /**
     * Parse object potentially representing a NamedGroup.
     * @param o
     * @return Parse result
     */
    NamedGroup.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new NamedGroup(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid NamedGroup: ".concat(e.message));
        }
    };
    return NamedGroup;
}());
exports.NamedGroup = NamedGroup;
/**
 * Class representing a minimal agency group.
 * Intended to be implemented by other models.
 * [Spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Models/AgencyGroup.md#MinimalAgencyGroup)
 */
var MinimalAgencyGroup = /** @class */ (function () {
    function MinimalAgencyGroup(id, name) {
        this.id = id;
        this.name = name;
    }
    return MinimalAgencyGroup;
}());
exports.MinimalAgencyGroup = MinimalAgencyGroup;
/**
 * Class representing a minimal agency group.
 * Intended to be implemented by other models.
 * @TODO Remove `isMember` field
 * [Spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Models/AgencyGroup.md#MinimalAgencyGroup)
 */
var MinimalDispatchGroup = /** @class */ (function () {
    function MinimalDispatchGroup(id, name, isMember) {
        this.id = id;
        this.name = name;
        this.isMember = isMember;
    }
    /**
     * Parse object potentially representing a MinimalDispatchGroup.
     * @param o
     * @return Parse result
     */
    MinimalDispatchGroup.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new MinimalDispatchGroup(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getBooleanOrNull(o, 'member')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid MinimalDispatchGroup: ".concat(e.message));
        }
    };
    return MinimalDispatchGroup;
}());
exports.MinimalDispatchGroup = MinimalDispatchGroup;
/**
 * Class representing a minimal agency group.
 * Intended to be implemented by other models.
 * [Spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Models/AgencyGroup.md#SearchAgencyGroup)
 */
var SearchDispatchGroup = /** @class */ (function () {
    function SearchDispatchGroup(id, name, isMember) {
        this.id = id;
        this.name = name;
        this.isMember = isMember;
    }
    /**
     * Parse object potentially representing a MinimalDispatchGroup.
     * @param o
     * @return Parse result
     */
    SearchDispatchGroup.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SearchDispatchGroup(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getBooleanOrNull(o, 'member')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SearchDispatchGroup: ".concat(e.message));
        }
    };
    return SearchDispatchGroup;
}());
exports.SearchDispatchGroup = SearchDispatchGroup;
/**
 * Class representing a basic agency group and providing a static parse method.
 * [Spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Models/AgencyGroup.md#BasicAgencyGroup)
 */
var BasicAgencyGroup = /** @class */ (function () {
    function BasicAgencyGroup(id, name, color) {
        this.id = id;
        this.name = name;
        this.color = color;
    }
    /**
     * Parse object potentially representing a BasicAgencyGroup.
     * @param o
     * @return Parse result
     */
    BasicAgencyGroup.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new BasicAgencyGroup(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'color')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid BasicAgencyGroup: ".concat(e.message));
        }
    };
    /**
     * Compare BasicAgencyGroup instances.
     * @param a
     * @param b
     * @retrun Number representing comparison.
     */
    BasicAgencyGroup.compare = function (a, b) {
        return a.name.localeCompare(b.name);
    };
    return BasicAgencyGroup;
}());
exports.BasicAgencyGroup = BasicAgencyGroup;
/**
 * Class representing an agency group and providing a static parse method.
 */
var AgencyGroup = /** @class */ (function () {
    function AgencyGroup(id, name, type, color, membersCount, agencyMembersCount, emailDsts, alertOverrides) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.color = color;
        this.membersCount = membersCount;
        this.agencyMembersCount = agencyMembersCount;
        this.emailDsts = emailDsts;
        this.alertOverrides = alertOverrides;
    }
    /**
     * Parse object potentially representing an AgencyGroup.
     * @param o
     * @return Parse result
     */
    AgencyGroup.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new AgencyGroup(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getEnum(o, 'type', AgencyGroupTypeEnum), cerealParse_1.ParseUtils.getStringOrNull(o, 'color'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'membersCount'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'agencyMembersCount'), cerealParse_1.ParseUtils.getArrayOrNull(o, 'emailDsts'), cerealParse_1.ParseUtils.getArrayOfSubobjectsOrNull(o, 'alertOverrides', override_1.GroupAlertOverride.parse, 'warn')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid AgencyGroup: ".concat(e.message));
        }
    };
    /**
     * Compare AgencyGroup instances.
     * @param a
     * @param b
     * @retrun Number representing comparison.
     */
    AgencyGroup.compare = function (a, b) {
        return a.name.localeCompare(b.name);
    };
    return AgencyGroup;
}());
exports.AgencyGroup = AgencyGroup;
/**
 * Class representing client dispatch group permissions and providing a static parse method.
 */
var ClientDispatchGroupPermissions = /** @class */ (function () {
    function ClientDispatchGroupPermissions(canSend, canRespond) {
        this.canSend = canSend;
        this.canRespond = canRespond;
    }
    /**
     * Copy ClientDispatchGroupPermissions instance.
     * @return New, identical ClientDispatchGroupPermissions
     */
    ClientDispatchGroupPermissions.prototype.copy = function () {
        return new ClientDispatchGroupPermissions(this.canSend, this.canRespond);
    };
    /**
     * Parse object potentially representing a ClientDispatchGroupPermissions.
     * @param o
     * @return Parse result
     */
    ClientDispatchGroupPermissions.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ClientDispatchGroupPermissions(cerealParse_1.ParseUtils.getBoolean(o, 'canSend'), cerealParse_1.ParseUtils.getBoolean(o, 'canRespond')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ClientDispatchGroupPermissions Object: ".concat(e.message));
        }
    };
    return ClientDispatchGroupPermissions;
}());
exports.ClientDispatchGroupPermissions = ClientDispatchGroupPermissions;
/**
 * Class representing client messaging group conditions and providing a static parse method.
 */
var ClientMessagingGroupPermissions = /** @class */ (function () {
    function ClientMessagingGroupPermissions(canSend) {
        this.canSend = canSend;
    }
    /**
     * Copy ClientMessagingGroupPermissions instance.
     * @return New, identical ClientMessagingGroupPermissions
     */
    ClientMessagingGroupPermissions.prototype.copy = function () {
        return new ClientMessagingGroupPermissions(this.canSend);
    };
    /**
     * Parse object potentially representing a ClientMessagingGroupPermissions.
     * @param o
     * @return Parse result
     */
    ClientMessagingGroupPermissions.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ClientMessagingGroupPermissions(cerealParse_1.ParseUtils.getBoolean(o, 'canSend')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ClientMessagingGroupPermissions Object: ".concat(e.message));
        }
    };
    return ClientMessagingGroupPermissions;
}());
exports.ClientMessagingGroupPermissions = ClientMessagingGroupPermissions;
/**
 * Class representing a client dispatch group and providing a static parse method.
 */
var ClientDispatchGroup = /** @class */ (function () {
    function ClientDispatchGroup(id, name, type, color, permissions, responseOptions) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.color = color;
        this.permissions = permissions;
        this.responseOptions = responseOptions;
    }
    /**
     * Parse object potentially representing a ClientDispatchGroup.
     * @param o
     * @return Parse result
     */
    ClientDispatchGroup.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ClientDispatchGroup(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), AgencyGroupTypeEnum.dispatch, cerealParse_1.ParseUtils.getString(o, 'color'), cerealParse_1.ParseUtils.getSubobject(o, 'permissions', ClientDispatchGroupPermissions.parse), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'responseOptions', responseOption_1.ClientResponseOption.parse, 'warn')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ClientDispatchGroup Object: ".concat(e.message));
        }
    };
    return ClientDispatchGroup;
}());
exports.ClientDispatchGroup = ClientDispatchGroup;
/**
 * Class representing a client messaging group and providing a static parse method.
 */
var ClientMessagingGroup = /** @class */ (function () {
    function ClientMessagingGroup(id, name, type, color, permissions) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.color = color;
        this.permissions = permissions;
    }
    /**
     * Parse object potentially representing a ClientMessagingGroup.
     * @param o
     * @return Parse result
     */
    ClientMessagingGroup.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ClientMessagingGroup(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), AgencyGroupTypeEnum.messaging, cerealParse_1.ParseUtils.getString(o, 'color'), cerealParse_1.ParseUtils.getSubobject(o, 'permissions', ClientMessagingGroupPermissions.parse)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ClientMessagingGroup Object: ".concat(e.message));
        }
    };
    return ClientMessagingGroup;
}());
exports.ClientMessagingGroup = ClientMessagingGroup;
/**
 * Parse object potentially representing a ClientGroup.
 * @param o
 * @return Parse result
 */
function parseClientGroup(o) {
    try {
        var groupType = cerealParse_1.ParseUtils.getEnum(o, 'type', AgencyGroupTypeEnum);
        if (groupType == AgencyGroupTypeEnum.dispatch) {
            return ClientDispatchGroup.parse(o);
        }
        else {
            return ClientMessagingGroup.parse(o);
        }
    }
    catch (e) {
        return cerealParse_1.ParseUtils.parseFailure("Invalid ClientGroup Object: ".concat(e.message));
    }
}
var MinimalGroup = /** @class */ (function () {
    function MinimalGroup(id, name) {
        this.id = id;
        this.name = name;
    }
    MinimalGroup.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new MinimalGroup(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid MinimalGroup Model: ".concat(e.message));
        }
    };
    MinimalGroup.compare = function (u1, u2) {
        return u1.name.localeCompare(u2.name) || u1.id.localeCompare(u2.id);
    };
    return MinimalGroup;
}());
exports.MinimalGroup = MinimalGroup;
var MinimalMembership = /** @class */ (function () {
    function MinimalMembership(id, name) {
        this.id = id;
        this.name = name;
    }
    MinimalMembership.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new MinimalMembership(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid MinimalMembership Model: ".concat(e.message));
        }
    };
    return MinimalMembership;
}());
exports.MinimalMembership = MinimalMembership;
//# sourceMappingURL=group.js.map